import { List } from 'antd';
import { t } from 'i18next';
import { observer } from 'mobx-react-lite';
import { Card } from 'src/components/Card/Card';
import { DataView } from 'src/components/DataView/DataView';
import { Empty } from 'src/components/Empty/Empty';
import { CommentDto } from 'src/generated-api-client';
import { LoanApplicationCommentsStore } from 'src/stores/LoanApplicationCommentsStore/LoanApplicationCommentsStore';
import styled from 'styled-components';

const store = LoanApplicationCommentsStore;

export const LoanApplicationCommentsList = observer(() => {
    return (
        <StyledList
            dataSource={store.list}
            loading={store.listLoader.isLoading}
            locale={{
                emptyText: (
                    <Empty
                        description={t('LoanApplication.Comments.NoComments')}
                    />
                ),
            }}
            renderItem={(item) => {
                const comment = item as unknown as CommentDto;

                return (
                    <Card key={comment.id}>
                        <StyledCommentHeader>
                            <StyledAuthor value={comment.createdBy} />
                            <StyledCreatedAt
                                value={comment.createdAt}
                                formatValue="dateTimeSeconds"
                            />
                        </StyledCommentHeader>
                        <DataView
                            value={comment.comment}
                            formatValue="textPreWrap"
                        />
                    </Card>
                );
            }}
        />
    );
});

const StyledList = styled(List)`
    margin-left: 0 !important;
`;

const StyledCommentHeader = styled.div`
    display: flex;
    align-items: baseline;
    gap: 10px;
    margin-bottom: 0.5rem;
`;

const StyledAuthor = styled(DataView)`
    .data-view__value {
        font-weight: 600;
    }
`;

const StyledCreatedAt = styled(DataView)`
    .data-view__value {
        font-size: 0.875rem;
        color: var(--label-color);
    }
`;
